import app from 'flarum/forum/app';
import featureModules from './features';
import termsExtend from './features/terms/extend';
export const extend = [...termsExtend];
app.initializers.add('dia-theme', () => {
  featureModules.forEach(registerFeature => registerFeature());
});